// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__FRUKm","footer":"ModalCreateQualiphyProcedure_footer__lLCx5","additionData":"ModalCreateQualiphyProcedure_additionData__3ijLo"};